<template>
    <v-card flat max-width="950px" class="mx-auto transparent pb-12">
        <HeadRoot 
            title="Career Map"
            :length="0"
            btn_txt=""
            btn_to="" />

        <div class="display-1 text-center primary--text font-weight-medium mt-8 d-flex justify-center align-center" v-if="loaded">
            <div class="mr-2">TOP JOB</div>
        </div>

        <div class="text-center">
            <v-btn text class="accent--text" @click="$router.push('/map-of-careers/best-jobs')">
                <v-icon small color="accent" left>fa-angle-left</v-icon>
                Back to TOP jobs
            </v-btn>
        </div> 

        <v-divider class="mt-3 mb-6"></v-divider>

        <v-card outlined v-if="loaded">
            <div class="pa-6 primary">
                <div class="display-1 white--text">{{item.name}}</div>
            </div>

            <div class="pa-6 pb-12">
                <div class="body-2 font-weight-bold primary--text text--darken-1">DESCRIPTION</div>
                <div v-html="item.description"></div>

                <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">ANNUAL MEAN WAGE</div>
                <div>${{formatAmount(item.wage)}}</div>

                <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">UPWARD MOBILITY</div>
                <div v-html="item.upwardMobility"></div>

                <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">STRESS LEVEL</div>
                <div v-html="item.stressLevel"></div>

                <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">FLEXIBILITY</div>
                <div v-html="item.flexibility"></div>

                <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">RECOMMENDED MAJORS</div>
                <div v-html="item.recommendedMajors"></div>

                <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6" v-if="item.top3Univ">TOP 3 UNIVERSITIES</div>
                <div v-html="item.top3Univ" v-if="item.top3Univ"></div>

                <div class="body-2 font-weight-bold primary--text text--darken-1 mt-6">A DAY IN THE LIFE OF THIS PROFESSION</div>
                <a v-html="item.day" target="_blank" :href="item.day" class="accent--text"></a>
            </div>
        </v-card>

        <SendingLoader v-else />
    </v-card>
</template>

<script>
import _ from 'lodash'
import Helpers from '@/services/helpers'
import Careers from '@/firebase/careers'

export default {
    data: () => ({
        loaded: false,
        items: null
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Careers.getBestJob(this.$route.params.id)
                    .then(response => {
                        if (response.status == true) {
                            this.item = response.doc.data();
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>

<style>
    b {
        font-size:14px;
    }
</style>